export default "__VITE_ASSET__Fu0xThuD__"